import { Component, ElementRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { DialogService, tr } from '@kpd/framework-ngx';
import { UserFacade } from 'app/shared/services/facades/user.facade';
import { UserService } from 'app/shared/services/user.service';
import { MessageService } from 'primeng/api';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-import',
  template: `
    <div class="flex-row">
      <kpd-action
        icon="import"
        [title]="'Import' | translate"
        [disable]="loading"
        (action)="showImport = true"
        *ngIf="!showImport"
      >
      </kpd-action>
      <span *ngIf="showImport"
        ><input
          #filePicker
          class="hidden"
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          (change)="onImport($event)"
          id="filePicker"
      /></span>
      <kpd-action
        icon="cancel"
        [title]="'Cancel' | translate"
        [disable]="loading"
        (action)="showImport = false"
        *ngIf="showImport"
      >
      </kpd-action>
    </div>
  `,
})
export class ImportComponent {
  showImport = false;
  @ViewChild('filePicker', { static: false }) filePicker: ElementRef;

  @Output()
  importDone = new EventEmitter();

  constructor(
    private userService: UserService,
    private dialogService: DialogService,
    private userFacade: UserFacade,
    private messageService: MessageService,
  ) {}

  async onImport(evt: any): Promise<any> {
    const data = await evt.target.files[0];
    const formData: FormData = new FormData();
    formData.append('importFile', data);
    this.uploadFile(formData);
  }

  uploadFile(file: FormData): void {
    this.userFacade.sidepanelLoadingStarted();
    this.userFacade.overviewLoadingStarted();
    this.userService
      .importUsers(file)
      .pipe(
        catchError((err) => {
          this.messageService.add({
            severity: 'error',
            summary: tr('Error notification'),
            detail: err.businessErrors,
          });
          return of(undefined);
        }),
      )
      .subscribe(
        (result) => {
          if (!result) {
            // Error
            this.filePicker.nativeElement.value = null;
            this.userFacade.sidepanelLoadingFinished();
            this.userFacade.overviewLoadingFinished();
            return;
          }
          this.showImport = false;
          this.filePicker.nativeElement.value = null;

          let message = '';
          Array.from(Object.keys(result.result)).forEach((upn) => {
            const userResult = result.result[upn];
            message =
              message +
              `${upn}: ${userResult.isSuccess ? '✔️ ' : '✖️ '} ${userResult.message ? userResult.message : ''} \n`;
          });

          this.dialogService
            .open('importCompleted', {
              message: message,
              header: tr('Import Completed'),
            })
            .afterClosed()
            .subscribe(() => {});
          this.userFacade.sidepanelLoadingFinished();
          this.userFacade.overviewLoadingFinished();
          this.importDone.emit();
        },
        () => {
          this.filePicker.nativeElement.value = null;
          this.userFacade.sidepanelLoadingFinished();
          this.userFacade.overviewLoadingFinished();
          this.importDone.emit();
        },
      );
  }
}
